module.exports = __webpack_public_path__ + "static/media/Slide2.4855b57c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/Slide2.webp
// module id = 575
// module chunks = 4